import React from 'react'
import { useAuth } from '../../../../context/Auth'
import { CreateCharacter } from './components/CreateCharacter/CreateCharacter'
import { CharacterSheet } from './components/CharacterSheet/CharacterSheet'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { mutationJoinGame } from '../../../../api/mutations'
import { gameCharsQueryKey } from '../../../../api/queries'
import { useGlobalError } from '../../../../context/GlobalError'
import { GmCharactersPanel } from './components/GmCharactersPanel/GmCharactersPanel'
import { IGame } from '../../../../api/types/game'
import { CharacterLoader } from './components/CharacterLoader/CharacterLoader'
import { ICharacter } from '../../../../api/types/character'
import { extractMessage } from '../../../../utils'
import { ActionsApprovalPanel } from './components/ActionsApprovalPanel/ActionsApprovalPanel'

interface Props {
  game: IGame
  showChatTab?: () => void
}

export const CharacterTab: React.FC<Props> = ({ game, showChatTab, ...props }) => {
  const auth = useAuth()
  const { addError } = useGlobalError()
  const queryClient = useQueryClient()

  const { mutate: joinGame } = useMutation(
    (char_id: number) => mutationJoinGame(char_id, game.id),
    {
      onError: (err: any) => {
        addError(extractMessage(err) || 'Nie udało się dołączyć do gry', err?.status)
      },
      onSuccess: async () => {
        queryClient.invalidateQueries(gameCharsQueryKey(game.id))
      },
    }
  )

  return (
    <>
      {auth && (
        <>
          {auth.gm && <GmCharactersPanel showChatTab={showChatTab} game={game} />}
          {auth.gm && <ActionsApprovalPanel game={game} />}
          {!auth.gm && !auth.character_id && <CreateCharacter afterCreate={joinGame} />}
          {!auth.gm && auth.character_id && (
            <CharacterLoader character_id={auth.character_id}>
              {(char: ICharacter) => (
                <CharacterSheet showChatTab={showChatTab} char={char} game_id={game.id} />
              )}
            </CharacterLoader>
          )}
        </>
      )}
    </>
  )
}
